import { defineMessages } from 'react-intl';

const messages = defineMessages({
  addPetTitle: {
    id: 'App.Household.PetsSection.PetModal.AddPetTitle',
    defaultMessage: 'Add Pet',
  },
  navigationLabel: {
    id: 'App.Household.PetsSection.PetModal.NavigationLabel',
    defaultMessage: 'Pet',
  },
  sectionTitle: {
    id: 'App.Household.PetsSection.PetModal.SectionTitle',
    defaultMessage: 'Pet Information',
  },
  name: {
    id: 'App.Household.PetsSection.PetModal.Name',
    defaultMessage: 'Name',
  },
  petType: {
    id: 'App.Household.PetsSection.PetModal.PetType',
    defaultMessage: 'Pet',
  },
  petBreed: {
    id: 'App.Household.PetsSection.PetModal.PetBreed',
    defaultMessage: 'Type',
  },
  weight: {
    id: 'App.Household.PetsSection.PetModal.Weight',
    defaultMessage: 'Weight (lbs)',
  },
  petTag: {
    id: 'App.Household.PetsSection.PetModal.PetTag',
    defaultMessage: 'Pet Tag',
  },
  isServiceAnimal: {
    id: 'App.Household.PetsSection.PetModal.IsServiceAnimal',
    defaultMessage: 'Service Animal?',
  },
  startDate: {
    id: 'App.Household.PetsSection.PetModal.StartDate',
    defaultMessage: 'Start Date',
  },
  endDate: {
    id: 'App.Household.PetsSection.PetModal.EndDate',
    defaultMessage: 'End Date',
  },
  endDateBeforeStartDate: {
    id: 'App.Household.PetsSection.PetModal.EndDateBeforeStartDate',
    defaultMessage: 'End Date cannot be before Start Date',
  },
  endDateInFuture: {
    id: 'App.Household.PetsSection.PetModal.EndDateInFuture',
    defaultMessage: 'End Date cannot be in the future',
  },
  startDateBeforeMoveIn: {
    id: 'App.Household.PetsSection.PetModal.StartDateBeforeMoveIn',
    defaultMessage: 'Start Date cannot be before the Household Move-In Date',
  },
  endDateBeforeMoveIn: {
    id: 'App.Household.PetsSection.PetModal.EndDateBeforeMoveIn',
    defaultMessage: 'End Date cannot be before the Household Move-In Date',
  },
  choose: {
    id: 'App.Household.PetsSection.PetModal.Choose',
    defaultMessage: 'Choose',
  },
  required: {
    id: 'App.Household.PetsSection.PetModal.Required',
    defaultMessage: 'Required',
  },
  optional: {
    id: 'App.Household.PetsSection.PetModal.Optional',
    defaultMessage: 'Optional',
  },
  requiredError: {
    id: 'App.Household.PetsSection.PetModal.RequiredError',
    defaultMessage: 'This field is required',
  },
  invalidWeight: {
    id: 'App.Household.PetsSection.PetModal.InvalidWeight',
    defaultMessage: 'Weight must be greater than 0',
  },
  petTagMaxLength: {
    id: 'App.Household.PetsSection.PetModal.PetTagMaxLength',
    defaultMessage: 'Pet Tag must be 20 characters or fewer',
  },
  petTagPattern: {
    id: 'App.Household.PetsSection.PetModal.PetTagPattern',
    // eslint-disable-next-line max-len
    defaultMessage:
      'Pet Tag can only contain letters, numbers, spaces, periods, apostrophes and hyphens',
  },
  delete: {
    id: 'App.Household.PetsSection.PetModal.Delete',
    defaultMessage: 'Delete',
  },
  deleteOpenCertTooltip: {
    id: 'App.Household.PetsSection.PetModal.DeleteOpenCertTooltip',
    defaultMessage:
      'There is an open certification. To delete this pet, you must ' +
      'complete or cancel the open certification.',
  },
  deleteConfirmTitle: {
    id: 'App.Household.PetsSection.PetModal.DeleteConfirmTitle',
    defaultMessage: 'Delete Pet',
  },
  deleteConfirmBanner: {
    id: 'App.Household.PetsSection.PetModal.DeleteConfirmBanner',
    // eslint-disable-next-line max-len
    defaultMessage:
      'This permanently deletes this pet and its history. ' +
      'This action cannot be undone.',
  },
  deleteConfirmBody: {
    id: 'App.Household.PetsSection.PetModal.DeleteConfirmBody',
    defaultMessage: 'Are you sure you want to delete {name}?',
  },
  unsupportedPetBanner: {
    id: 'App.Household.PetsSection.PetModal.UnsupportedPetBanner',
    defaultMessage:
      'This pet is pending on an application and cannot be edited here. ' +
      'Manage it from the application instead.',
  },
  saveSuccessTitle: {
    id: 'App.Household.PetsSection.PetModal.SaveSuccessTitle',
    defaultMessage: 'Success',
  },
  addSuccessMessage: {
    id: 'App.Household.PetsSection.PetModal.AddSuccessMessage',
    defaultMessage: 'Pet added',
  },
  updateSuccessMessage: {
    id: 'App.Household.PetsSection.PetModal.UpdateSuccessMessage',
    defaultMessage: 'Pet updated',
  },
  deleteSuccessMessage: {
    id: 'App.Household.PetsSection.PetModal.DeleteSuccessMessage',
    defaultMessage: 'Pet deleted',
  },
  saveErrorTitle: {
    id: 'App.Household.PetsSection.PetModal.SaveErrorTitle',
    defaultMessage: 'Error',
  },
  saveErrorMessage: {
    id: 'App.Household.PetsSection.PetModal.SaveErrorMessage',
    defaultMessage: 'Unable to save the pet. Please try again.',
  },
  deleteErrorMessage: {
    id: 'App.Household.PetsSection.PetModal.DeleteErrorMessage',
    defaultMessage: 'Unable to delete the pet. Please try again.',
  },
});

export default messages;
